// extracted by mini-css-extract-plugin
export default {"component":"JMdM6J","text":"s2i7iJ"};